<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <MainPage />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import MainPage from '@/components/MainPage.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld,
    MainPage
  }
}
</script>
